import ErrorHandler from '@/components/Error/ErrorHandler'
import SaldoAntecipadoItem from '@/components/Fatura/SaldoAntecipadoItem'
import '@/components/Fatura/SaldoAntecipado.scss'
import Loading from '@/components/Loading'
import useAuth from '@/contexts/useAuth'
import { getSaldoAntecipado } from '@/services/saldo-antecipado'
import { formatMoney } from '@/utils'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

export default function SaldoAntecipado() {
    const { t } = useTranslation()
    const { empresaURL } = useParams<{ empresaURL: string }>()
    const { user } = useAuth()
    const [disponivel, setDisponivel] = useState(0)
    const [extrato, setExtrato] = useState<Awaited<ReturnType<typeof getSaldoAntecipado>>['extrato']>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!user?.CdCliente) return

        let cancelled = false
        ;(async () => {
            setIsLoading(true)
            try {
                const data = await getSaldoAntecipado()
                if (cancelled) return
                setDisponivel(data.disponivel)
                setExtrato(data.extrato)
            } catch (err) {
                if (!cancelled) setError(err as Error)
            } finally {
                if (!cancelled) setIsLoading(false)
            }
        })()

        return () => {
            cancelled = true
        }
    }, [user?.CdCliente])

    if (error) return <ErrorHandler error={error} />
    if (!user || isLoading) return <Loading type="primary" />

    return (
        <div className="flex flex-col gap-4 px-0 py-1 sm:px-1 lg:py-2">
            {empresaURL ? (
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <Link className="btn btn-outline-primary btn-sm" to={`/${empresaURL}/faturas`}>
                        {t('Voltar')}
                    </Link>
                    <h1 className="m-0 text-lg font-bold text-slate-900">{t('Saldo Antecipado')}</h1>
                </div>
            ) : null}

            <div className="saldo-antecipado-summary">
                <span className="saldo-antecipado-summary-label">{t('Saldo Disponível')}</span>
                <strong className="saldo-antecipado-summary-valor">{formatMoney(disponivel)}</strong>
            </div>

            {extrato.length === 0 ? (
                <p className="saldo-antecipado-empty">{t('Nenhum movimento de saldo')}</p>
            ) : (
                <div className="saldo-antecipado-list">
                    {extrato.map((item, index) => (
                        <SaldoAntecipadoItem
                            key={`${item.Operacao}-${item.CdSaldo}-${item.Data ?? ''}-${index}`}
                            item={item}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}
